import type { SecurityStatus } from '../types';

interface Props {
  status: SecurityStatus;
}

const STATUS_LABELS: Record<SecurityStatus, string> = {
  APPROVED: 'Approved',
  APPROVED_WITH_WARNINGS: 'Approved with warnings',
  BLOCKED: 'Blocked',
  PENDING: 'Pending',
  ERROR: 'Error'
};

const STATUS_CLASSES: Record<SecurityStatus, string> = {
  APPROVED:
    'bg-emerald-100/80 text-emerald-900 ring-1 ring-emerald-500/40 dark:bg-emerald-500/15 dark:text-emerald-200 dark:ring-emerald-400/60',
  APPROVED_WITH_WARNINGS:
    'bg-amber-100/80 text-amber-900 ring-1 ring-amber-500/40 dark:bg-amber-500/15 dark:text-amber-200 dark:ring-amber-400/60',
  BLOCKED:
    'bg-red-100/80 text-red-900 ring-1 ring-red-500/40 dark:bg-red-500/15 dark:text-red-200 dark:ring-red-400/60',
  PENDING:
    'bg-slate-100/80 text-slate-900 ring-1 ring-slate-400/40 dark:bg-slate-500/15 dark:text-slate-200 dark:ring-slate-400/60',
  ERROR:
    'bg-rose-100/80 text-rose-900 ring-1 ring-rose-500/40 dark:bg-rose-500/15 dark:text-rose-200 dark:ring-rose-400/60'
};

export function StatusBadge({ status }: Props) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold shadow-sm ${STATUS_CLASSES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
